export default {
  components: {},

  mixins: [],

  data() {
    return {
      themeMenu: false
    }
  },

  methods: {
    onSelectThemeClick(val) {
      this.setThemeMode(val)
      this.$nextTick(() => {
        window.callAS(window.SocketCommand.Account.UpdateTheme, {ThemeMode: this.posUser.theme_mode})
        this.themeMenu = false
      })
    }
  }
}
